import { HttpInterceptorFn } from '@angular/common/http';
import * as moment from 'moment';

export const dateSerializeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body instanceof FormData) {
    return next(req);
  }

  if (!req.body || typeof req.body !== 'object') {
    return next(req);
  }

  const body = convertDates(req.body);
  return next(req.clone({ body }));
};

function convertDates(obj: any): any {
  if (moment.isMoment(obj)) {
    return obj.format('YYYY-MM-DD');
  }

  if (obj instanceof Date) {
    const y = obj.getFullYear();
    const m = String(obj.getMonth() + 1).padStart(2, '0');
    const d = String(obj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  if (Array.isArray(obj)) {
    return obj.map(v => convertDates(v));
  }

  if (obj !== null && typeof obj === 'object') {
    const result: any = {};
    for (const key of Object.keys(obj)) {
      result[key] = convertDates(obj[key]);
    }
    return result;
  }

  return obj;
}